import { render, staticRenderFns } from "./TrancheListing.vue?vue&type=template&id=a5e764c8&"
import script from "./TrancheListing.vue?vue&type=script&lang=js&"
export * from "./TrancheListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports